<template>
	<div class="wrapper">
		<tree-node
			v-for="item in internalState"
			:node="item"
			:key="item.id"
			:options="computedOptions"
			@node:click="onNodeClick"
			@node:update="$emit('node:update', $event)"
			@node:addChild="$emit('node:addChild', $event)"
			@node:move="$emit('node:move', $event)"
			@node:delete="$emit('node:delete', $event)"
		>
		</tree-node>

		<!-- Loading -->
		<div class="loading" v-if="isLoading">
			<j-spinner />
		</div>
	</div>
</template>

<script>
import TreeNode from "./TreeNode.vue"
import JSpinner from "@/components/JSpinner/"

export default {
	name: "j-base-tree",
	components: { TreeNode, JSpinner },
	props: {
		value: {
			required: true,
			default: null,
			validator(val) {
				return val === null || val instanceof Object
			}
		},
		options: {
			type: [Object, null],
			default: () => ({})
		},
		isLoading: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			internalState: []
		}
	},
	computed: {
		computedOptions() {
			// Definition of default options that is possibly overriden by passed prop
			return {
				hasUpdateAction: true,
				hasAddChildAction: true,
				hasMoveAction: true,
				hasDeleteAction: true,
				updateActionLabel: this.$t("update"),
				moveActionLabel: this.$t("move"),
				addChildActionLabel: this.$t("add_sub"),
				deleteActionLabel: this.$t("delete"),
				...this.options
			}
		}
	},
	methods: {
		onNodeClick(node) {
			node.isExpanded = !node.isExpanded

			// Reset all selections in the tree
			this.resetSelection(this.internalState)
			node.isSelected = true

			this.$emit("node:click", node)
			this.$emit("input", this.internalState)
		},

		resetSelection(tree) {
			const recursion = nodeArray => {
				nodeArray.forEach(node => {
					node.isSelected = false
					if (node.children && node.children.length > 0) {
						recursion(node.children)
					}
				})
			}

			recursion(tree)
		}
	},

	watch: {
		// Tree has its own internal state that is derived from value
		// Anytime value changes, internal state is updated
		// Internal and external states are in sync thanks to v-model
		value: {
			handler() {
				this.internalState = JSON.parse(JSON.stringify(this.value))
			},
			immediate: true,
			deep: true
		}
	}
}

/* Example of data for tree
treeData: [
  {
    id: "1",
    label: "Hey",
    isExpanded: false,
    isSelected: false,
    icon: "people",
    children: [
      {
        id: "2",
        label: "Under",
        isExpanded: false,
        isSelected: false,
        children: [
          {
            id: "3",
            label: "UNder more",
            isExpanded: false,
            isSelected: false
          }
        ]
      }
    ]
  }
], 
*/
</script>
<style scoped>
.wrapper {
	position: relative;
}

.loading {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(255, 255, 255, 0.6);
}
</style>
